"use client";

import React from "react";
import { MonitorPlay, Download, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Shared Cost Model",
  description: "Maximize your marketing budget by sharing the mailer with other local businesses. Premium exposure at a fraction of the traditional cost.",
  icon: MonitorPlay
}, {
  title: "Category Exclusivity",
  description: "We guarantee zero competition on your postcard. You are the only business in your category, ensuring 100% of the homeowner's attention.",
  icon: Download
}, {
  title: "Premium Quality",
  description: "High-gloss, heavy cardstock that commands attention. Our postcards are designed to feel as prestigious as the homes they land in.",
  icon: Zap
}];
export default function TheFlixStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224651" id="the-co-op-advantage" className="bg-muted text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scanline {
          0% { top: -10%; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { top: 110%; opacity: 0; }
        }
        .group:hover .scan-line-anim {
          animation: scanline 2s linear infinite;
        }
      `
    }} />

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-secondary tracking-tight mb-4">
            The Co-op Advantage
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Strategic direct mail engineered for Metro Atlanta's most exclusive neighborhoods. We handle the logistics; you get the leads.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="group relative overflow-hidden bg-card border-border hover:bg-gradient-to-b hover:from-card hover:to-primary/5 transition-all duration-500 rounded-lg shadow-lg">
                {}
                <div className="absolute inset-0 pointer-events-none overflow-hidden z-10 rounded-lg">
                  <div className="scan-line-anim absolute left-0 w-full h-[2px] bg-primary shadow-[0_0_15px_var(--color-primary)] opacity-0" />
                  {}
                  <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                </div>

                <CardHeader className="relative z-20 pb-4">
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-md bg-background border border-border shadow-sm">
                    <Icon className="size-7 text-secondary transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <CardTitle className="text-xl font-bold text-secondary font-default tracking-wide">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-20">
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}